import { gql } from '@apollo/client';

export const GET_TIPO_PROFESIONALES = gql`
    query GetTipoProfesionales {
        tipoProfesionales {
            success
            error
            valorEsperado {
                idTipoProfesional
                descripcion
                abreviacion
                tipoLiquidacion
            }
        }
    }
`;